module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0675.51d60761.jpg";